export const wasteCategories: TableModule = {
    name: "wasteCategories",
    route: "spa.system.wasteCategories",
    defaultOrder: {
        column: "created_at",
        direction: "desc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        },
        {
            name: "description",
            sortable: false,
        },
        {
            name: "created_at",
            sortable: true,
        }
    ],
    filters: [
        {
            name: "id",
            column: "waste_categories.id",
            type: "numeric"
        },
        {
            name: "name",
            column: "waste_categories.name",
            type: "string"
        },
        {
            name: "created_at",
            column: "waste_categories.created_at",
            type: "date"
        }
    ],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "wasteCategories"]
        },
    ]
}
